export default "__VITE_ASSET__cf81140a__"